import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import Form from "./Form";

const LoginPage = () => {
  const theme = useTheme();
  const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isNonMobileScreens ? "row" : "column",
        position: "absolute",
        inset: 0,
        overflow: "hidden",
      }}
    >
      {/* ── Left panel ── */}
      {isNonMobileScreens && (
        <Box
          sx={{
            width: "45%",
            flexShrink: 0,
            backgroundColor: theme.palette.background.default,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: "3rem 2.5rem",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Decorative circles */}
          <Box sx={{
            position: "absolute", bottom: "-60px", right: "-60px",
            width: "260px", height: "260px", borderRadius: "50%",
            border: "50px solid rgba(29,158,117,0.07)", pointerEvents: "none",
          }} />
          <Box sx={{
            position: "absolute", top: "-80px", left: "-80px",
            width: "320px", height: "320px", borderRadius: "50%",
            border: "60px solid rgba(29,158,117,0.04)", pointerEvents: "none",
          }} />

          {/* Brand */}
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px", position: "relative" }}>
            <Box sx={{
              width: "34px", height: "34px",
              backgroundColor: theme.palette.secondary.main,
              borderRadius: "8px", display: "flex",
              alignItems: "center", justifyContent: "center", flexShrink: 0,
            }}>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M3 9h5M9 3v5M9 9l4 4" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="9" cy="9" r="7" stroke="#fff" strokeWidth="1.2" opacity="0.4" />
              </svg>
            </Box>
            <Typography sx={{
              fontFamily: "'DM Serif Display', serif",
              fontSize: "20px", fontWeight: 400,
              color: theme.palette.secondary.white,
            }}>
              PesaTrack
            </Typography>
          </Box>

          {/* Hero content */}
          <Box sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", py: "2rem", position: "relative" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "6px", mb: "1rem" }}>
              <Box sx={{ width: "5px", height: "5px", borderRadius: "50%", backgroundColor: theme.palette.secondary.main }} />
              <Typography sx={{
                fontSize: "11px", fontWeight: 500,
                letterSpacing: "0.12em", textTransform: "uppercase",
                color: theme.palette.secondary.main,
              }}>
                Inventory &amp; Finance
              </Typography>
            </Box>

            <Typography sx={{
              fontFamily: "'DM Serif Display', serif",
              fontSize: "clamp(28px, 3vw, 42px)",
              color: theme.palette.secondary.white,
              lineHeight: 1.2, fontWeight: 400, mb: "1rem",
            }}>
              Efficient<br />
              <em style={{ fontStyle: "italic", color: theme.palette.secondary.medium }}>inventory,</em><br />
              pristine books.
            </Typography>

            <Typography sx={{
              fontSize: "14px",
              color: "rgba(255,255,255,0.45)",
              lineHeight: 1.7, maxWidth: "300px",
            }}>
              Real-time stock tracking, automated bookkeeping, and business insights — all in one place.
            </Typography>

            {/* Stats */}
            <Box sx={{ display: "flex", gap: "2rem", mt: "2rem" }}>
              {[
                { num: "99.9%", label: "Uptime" },
                { num: "50k+",  label: "Transactions" },
                { num: "24/7",  label: "Support" },
              ].map(({ num, label }) => (
                <Box key={label} sx={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                  <Typography sx={{ fontSize: "20px", fontWeight: 500, color: theme.palette.secondary.white }}>
                    {num}
                  </Typography>
                  <Typography sx={{ fontSize: "11px", color: "rgba(255,255,255,0.3)", letterSpacing: "0.04em" }}>
                    {label}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>

          <Typography sx={{ fontSize: "11px", color: "rgba(255,255,255,0.18)", position: "relative" }}>
            © 2026 PesaTrack. All rights reserved.
          </Typography>
        </Box>
      )}

      {/* ── Right panel (form) ── */}
      <Box
        sx={{
          flex: 1,
          backgroundColor: theme.palette.background.alt,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: isNonMobileScreens ? "2rem" : "2rem 1.25rem",
          overflowY: "auto",
        }}
      >
        {/* Mobile-only brand header */}
        {!isNonMobileScreens && (
          <Box sx={{ textAlign: "center", mb: "2rem" }}>
            <Typography sx={{
              fontFamily: "'DM Serif Display', serif",
              fontSize: "28px", fontWeight: 400,
              color: theme.palette.neutral.dark,
            }}>
              PesaTrack
            </Typography>
            <Typography sx={{ fontSize: "13px", color: theme.palette.neutral.main, mt: "4px" }}>
              Efficient Inventory Management, Pristine Bookkeeping
            </Typography>
          </Box>
        )}

        <Box sx={{ width: "100%", maxWidth: "400px" }}>
          <Form />
        </Box>
      </Box>
    </Box>
  );
};

export default LoginPage;